import dotenv from 'dotenv';
import path from 'path';

let hasInitialized = false;

const init = () => {
  if (hasInitialized) {
    return;
  }

  // In test environment, load test-specific environment variables
  const envFile = process.env.NODE_ENV === 'test' ? '../.env.test' : '../.env';

  dotenv.config({
    path: path.resolve(__dirname, envFile),
    quiet: true,
  });
  hasInitialized = true;
};

type EnvVars = {
  TODESKTOP_CLI_ENV: string;
  TODESKTOP_CLI_S3_BUCKET: string;
  TODESKTOP_CLI_FIREBASE_FUNCTIONS_BASE: string;
  TODESKTOP_CLI_FIREBASE_API_KEY: string;
  TODESKTOP_CLI_FIREBASE_AUTH_DOMAIN: string;
  TODESKTOP_CLI_FIREBASE_DATABASE_URL: string;
  TODESKTOP_CLI_FIRESTORE_HOST?: string;
  TODESKTOP_CLI_FIREBASE_PROJECT_ID: string;
  TODESKTOP_CLI_FIREBASE_STORAGE_BUCKET: string;
  TODESKTOP_CLI_FIREBASE_MESSAGING_SENDER_ID: string;
  TODESKTOP_CLI_FIREBASE_ID: string;
  TODESKTOP_CLI_SENTRY_DSN: string;
  SEGMENT_KEY: string;
};

export default () => {
  init();
  return process.env as NodeJS.ProcessEnv & EnvVars;
};
